import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_jrnl_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  amt_debit: fromDatatype.NumericDatatypeInterface;
  amt_credit: fromDatatype.NumericDatatypeInterface;
  reference_num: fromDatatype.VarcharDatatypeInterface;
  reference_num_1: fromDatatype.VarcharDatatypeInterface;
  reference_num_2: fromDatatype.VarcharDatatypeInterface;
  reference_num_3: fromDatatype.VarcharDatatypeInterface;
  reference_num_4: fromDatatype.VarcharDatatypeInterface;
  reference_num_5: fromDatatype.VarcharDatatypeInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  guid_cashbook: fromDatatype.GuidDataFieldInterface;
  guid_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_entity_line: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_jrnl_line_RowClass
  implements bl_fi_jrnl_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  amt_debit: fromDatatype.NumericDatatypeInterface;
  amt_credit: fromDatatype.NumericDatatypeInterface;
  reference_num: fromDatatype.VarcharDatatypeInterface;
  reference_num_1: fromDatatype.VarcharDatatypeInterface;
  reference_num_2: fromDatatype.VarcharDatatypeInterface;
  reference_num_3: fromDatatype.VarcharDatatypeInterface;
  reference_num_4: fromDatatype.VarcharDatatypeInterface;
  reference_num_5: fromDatatype.VarcharDatatypeInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  guid_cashbook: fromDatatype.GuidDataFieldInterface;
  guid_entity_hdr: fromDatatype.GuidDataFieldInterface;
  guid_entity_line: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
